import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';

import { Params } from '@angular/router';
import * as onboardingActions from '@store/onboarding/onboarding.actions';
import * as onboardingSelectors from '@store/onboarding/onboarding.selectors';
import { IKycApplication } from '../core/models/onboarding.model';

import {
  IOnboardingKYC,
  IOnboardingParams,
  IOnboardingSession,
} from '../core/models/onboarding.model';

@Injectable({ providedIn: 'root' })
export class OnboardingFacade {
  public information$: Observable<IOnboardingSession>;
  public auth10tix$: Observable<IOnboardingKYC>;
  public isLoading$: Observable<boolean>;
  public error$: Observable<boolean>;
  public customerValidation$: Observable<boolean>;
  public stepInfo$: Observable<IOnboardingParams>;

  constructor(private _store: Store) {
    this.information$ = this._store.select(onboardingSelectors.selectInformation);
    this.isLoading$ = this._store.select(onboardingSelectors.selectIsLoading);
    this.auth10tix$ = this._store.select(onboardingSelectors.selectAuth10tix);
    this.error$ = this._store.select(onboardingSelectors.selectIsError);
    this.customerValidation$ = this._store.select(onboardingSelectors.selectCustomerValidation);
    this.stepInfo$ = this._store.select(onboardingSelectors.selectStepInfo);
  }

  public requestOnboardingSession(step: number) {
    this._store.dispatch(onboardingActions.requestOnboardingSession({ step }));
  }

  public successRequestOnboardingSession(information: IOnboardingSession) {
    this._store.dispatch(onboardingActions.successRequestOnboardingSession({ information }));
  }

  public saveOnboardingStep(stepInfo: IOnboardingParams) {
    this._store.dispatch(onboardingActions.saveOnboardingStep({ stepInfo }));
  }

  public saveAuth10tixStatus() {
    this._store.dispatch(onboardingActions.saveAuth10tixStatus());
  }

  public requestAuth10tixStatus() {
    this._store.dispatch(onboardingActions.requestAuth10tixStatus());
  }

  public setKYCApplication(application: IKycApplication | Params) {
    this._store.dispatch(onboardingActions.setKYCApplication({ application }));
  }

  public listentAuth10tixStatus() {
    this._store.dispatch(onboardingActions.listentAuth10tixStatus());
  }

  public successAuth10tixStatuss(auth10tix: IOnboardingKYC) {
    this._store.dispatch(onboardingActions.successRequestAuth10tixStatus({ auth10tix }));
  }

  public getPreCustomer() {
    this._store.dispatch(onboardingActions.getPreCustomer());
  }
  // DEMO
  public setUnderReviewAuth10tixStatus(status: number) {
    this._store.dispatch(onboardingActions.setUnderReviewAuth10tixStatus({ status }));
  }
}
